import FilterSearch from '../filter-search/filter-search';

export default class TopSection {
  constructor(overlay) {
    this.formFilters = document.querySelector('.top-section__form');
    this.selectRegion = document.querySelector('.select-region');
    this.selectRegionButton = this.selectRegion.querySelector(
      '.select-region__button'
    );
    this.selectRegionSelect = this.selectRegion.querySelector(
      '.select-region__select'
    );
    this.filterSearch = document.querySelector('.filter-search');
    this.selectYear = document.querySelector('.select-year');
    this.selectYearOptionAll = document.querySelectorAll(
      '.select-year__option'
    );
    this.selectMonthAll = document.querySelectorAll('.select-month');
    this.monthDk = document.querySelector('.month-dk');
    this.carouselTime = document.querySelector('.carousel-time');
    this.carouselTimeYearWrapper = document.querySelector(
      '.carousel-time__years-wrapper'
    );
    this.carouselTimeYears = this.carouselTime.querySelector(
      '.carousel-time__years'
    );
    this.carouselNav = this.carouselTime.querySelector('.carousel-time__nav');
    this.carouselTimeMonth = this.carouselTime.querySelector(
      '.carousel-time__month'
    );
    this.carouselTimeYearCheckbox = this.carouselTime.querySelector(
      '.carousel-time__checkbox-input'
    );
    this.closeCarouselTime = document.querySelector('.close--carousel-time');
    this.topGlobalDateButton = document.querySelector(
      '.top-section__date-button'
    );
    this.arrowSelectButton = document.querySelector('.angle-svg--top-section');
    this.buttonApplyAll = document.querySelectorAll('.button--apply');
    this.closeSelectButton = document.querySelector('.close--select');
    this.monthDkActive = document.querySelector('.month-dk__list--active');
    this.dateButtonSpan = document.querySelector('.top-section__date-span');
    this.carouselCount = 0;
    this.index = 0;
    this.selectedYear = null;
    this.overlay = overlay;
  }

  _removeTimelineItem() {
    const monthDkItemAll = this.monthDk.querySelectorAll('.month-dk__item');

    [...monthDkItemAll].map(item => {
      item.classList.remove('month-dk__item--active');
    });

    [...this.selectMonthAll].map(item => {
      [...item].map(month => {
        month.removeAttribute('selected');
      });
    });
  }

  _removeClassSlider() {
    this.carouselTimeItemAll[this.index].classList.remove(
      'carousel-time__item--active'
    );
    this.monthDkListAll[this.index].classList.remove('month-dk__list--active');
    this.selectMonthAll[this.index].removeAttribute('selected');
    this.selectMonthAll[this.index].setAttribute('disabled', '');
    this.selectYearOptionAll[this.index].removeAttribute('selected', '');
  }

  _sliderNavButton(target) {
    this.carouselTimeItemAll = document.querySelectorAll(
      '.carousel-time__item'
    );
    this.monthDkListAll = document.querySelectorAll('.month-dk__list');
    this._removeClassSlider();

    target.classList.contains('carousel-time__button-prev')
      ? (this.index-- ,
        this.index < 0 && (this.index = this.carouselTimeItemAll.length - 1))
      : (this.index++ ,
        this.index >= this.carouselTimeItemAll.length && (this.index = 0));

    this.selectYear.options[this.index].selected = this.carouselTimeItemAll[
      this.index
    ];
    this.carouselTimeItemAll[this.index].classList.add(
      'carousel-time__item--active'
    );
    this.monthDkListAll[this.index].classList.add('month-dk__list--active');
    this.selectMonthAll[this.index].setAttribute('selected', '');
    this.selectMonthAll[this.index].removeAttribute('disabled', '');
    this.selectYearOptionAll[this.index].setAttribute('selected', '');
  }

  _closeCarouselTime() {
    this.carouselTime.classList.remove('carousel-time--visible');
    this.topGlobalDateButton.classList.remove(
      'top-section__date-button--active'
    );
    this.overlay.classList.remove('overlay--visible');

    document.body.classList.contains('scroll-lock') &&
      document.body.classList.remove('scroll-lock');
  }

  _activeCarouselTime() {
    this.carouselTime.classList.toggle('carousel-time--visible');
    this.topGlobalDateButton.classList.toggle(
      'top-section__date-button--active'
    );

    window.innerWidth <= 768 &&
      (this.overlay.classList.add('overlay--visible'),
        document.body.classList.add('scroll-lock'));
  }

  _createSelectRegion() {
    const selectRegionOptions = this.selectRegionSelect.options;

    const selectRegionMobile = `
      <div class="close close--select">
      <div class="close__line"></div>
      </div><span class="select-region__mobile-span">Регион</span>
      <div class="select-region__button-apply">
        <button type="submit" class="button button--apply">Применить</button>
      </div>
    `;
    const createRegionMobile = document.createElement('div');
    createRegionMobile.setAttribute(
      'class',
      'select-region__mobile select-region__mobile--hide'
    );
    createRegionMobile.innerHTML = selectRegionMobile;
    this.selectRegion.appendChild(createRegionMobile);

    const selectedSpan = document.createElement('span');
    selectedSpan.setAttribute('class', 'select-region__selected');
    selectedSpan.innerHTML =
      selectRegionOptions[this.selectRegionSelect.selectedIndex].innerHTML;
    this.selectRegionButton.appendChild(selectedSpan);

    const createListItems = document.createElement('ul');
    createListItems.setAttribute('class', 'select-region__list');

    for (let i = 0; i < selectRegionOptions.length; i++) {
      const createItem = document.createElement('li');
      createItem.setAttribute('class', 'select-region__item');
      createItem.setAttribute('data-value', selectRegionOptions[i].value);
      createItem.innerHTML = selectRegionOptions[i].innerHTML;

      createItem.addEventListener('click', e => {
        selectRegionOptions[i].selected = createItem;
        this._handleSelectOption(e.target, selectedSpan);
        window.innerWidth > 768 && this.formFilters.submit();
      });
      createListItems.appendChild(createItem);

      selectRegionOptions[i].selected &&
        this._handleSelectOption(createItem, selectedSpan);
    }
    createRegionMobile.insertBefore(
      createListItems,
      this.selectRegion.querySelector('.select-region__button-apply')
    );

    selectedSpan.addEventListener('click', e => this._toggleSelect(e.target));
  }

  _handleSelectOption(target, selectedSpan) {
    const sameAsSelected = target.parentElement.querySelector('.selected');
    sameAsSelected && sameAsSelected.classList.remove('selected');

    [...this.selectRegionSelect.options].map(option => {
      option.removeAttribute('selected');
      return (
        option.value === target.dataset.value &&
        ((selectedSpan.innerHTML = target.innerHTML),
          option.setAttribute('selected', ''),
          target.classList.add('selected'))
      );
    });

    window.innerWidth > 768 &&
      !this.selectRegion.querySelector('.select-region__mobile--hide') &&
      this._toggleSelect(target);
  }

  _toggleSelect() {
    window.innerWidth <= 768 &&
      (this.overlay.classList.add('overlay--visible'),
        document.body.classList.add('scroll-lock'));

    this.selectRegion
      .querySelector('.select-region__mobile')
      .classList.toggle('select-region__mobile--hide');
    this.arrowSelectButton.classList.toggle('angle-svg--rotate');
  }

  _closeSelect() {
    this.selectRegion
      .querySelector('.select-region__mobile')
      .classList.add('select-region__mobile--hide');
    this.arrowSelectButton.classList.remove('angle-svg--rotate');

    window.innerWidth <= 768 &&
      this.overlay.classList.remove('overlay--visible');

    document.body.classList.contains('scroll-lock') &&
      document.body.classList.remove('scroll-lock');
  }

  _setMonthName(target) {
    const year = document.querySelector('.carousel-time__item--active')
      .innerHTML;
    this.dateButtonSpan.innerText = `${target.getAttribute(
      'data-full-month'
    )}’ ${year.slice(-2)}`;
  }

  _createSelectYear() {
    const selectYearOptions = this.selectYear.options;

    const createCarouselList = document.createElement('ul');
    createCarouselList.setAttribute('class', 'carousel-time__list');

    for (let i = 0; i < selectYearOptions.length; i++) {
      const selectYearItem = document.createElement('li');
      selectYearItem.setAttribute('class', 'carousel-time__item');
      selectYearItem.setAttribute('data-id', i);

      selectYearOptions[i].selected &&
        (selectYearItem.classList.add('carousel-time__item--active'),
          (this.index = selectYearItem.dataset.id),
          (this.selectedYear = selectYearOptions[i].value));

      selectYearItem.innerHTML = selectYearOptions[i].innerHTML;

      createCarouselList.appendChild(selectYearItem);
    }
    this.carouselTimeYearWrapper.insertBefore(
      createCarouselList,
      this.carouselNav
    );
  }

  _createSelectMonth() {
    const carouselYearActive = document.querySelector(
      '.carousel-time__item--active'
    );
    [...this.selectMonthAll].map((month, k) => {
      const selectMonthOptions = month.options;

      const createMonthList = document.createElement('ul');
      createMonthList.setAttribute('class', 'month-dk__list');

      k === Number(carouselYearActive.dataset.id)
        ? (createMonthList.classList.add('month-dk__list--active'),
          month.setAttribute('selected', ''))
        : month.setAttribute('disabled', '');

      [...selectMonthOptions].map(option => {
        const selectMonthItem = document.createElement('li');
        selectMonthItem.setAttribute('class', 'month-dk__item');
        selectMonthItem.setAttribute(
          'data-full-month',
          option.getAttribute('data-full-month')
        );

        k === Number(carouselYearActive.dataset.id) &&
          option.selected &&
          (option.setAttribute('selected', ''),
            selectMonthItem.classList.add('month-dk__item--active'),
            this._setMonthName(selectMonthItem));
        selectMonthItem.innerHTML = option.innerHTML;

        if (option.dataset.active !== 'true') {
          selectMonthItem.classList.add('_not-available');
        }
        else {
          selectMonthItem.addEventListener('click', () => {
            this._removeTimelineItem();
            this._setMonthName(selectMonthItem);
            option.selected = selectMonthItem;
            option.setAttribute('selected', '');
            selectMonthItem.classList.add('month-dk__item--active');
            this.carouselTimeYearCheckbox.checked && this._toggleCheckbox();

            this.carouselTimeYearCheckbox.checked = false;

            window.innerWidth > 768 && this.formFilters.submit();
          });
        }

        createMonthList.appendChild(selectMonthItem);
      });

      this.monthDk.appendChild(createMonthList);
    });

    this.carouselTimeYearCheckbox.hasAttribute('checked') &&
      this._toggleCheckbox(this.carouselTimeYearCheckbox.checked);
  }

  _toggleCheckbox(checked) {
    const activeMonth = this.monthDk.querySelector('.month-dk__item--active');

    [...this.selectMonthAll].map(month => {
      month.hasAttribute('selected') &&
        (month.disabled = checked ? true : false);
    });

    if (checked) {
      activeMonth.classList.add('_disabled');
      this.dateButtonSpan.innerText = 'За все время';
    }
    else {
      const currentActive = activeMonth.parentElement
        .querySelector('._disabled');
      currentActive.classList.remove('_disabled');
      this._setMonthName(currentActive);
      this.carouselTimeYearCheckbox.removeAttribute('checked');
    }

    this.selectYear.disabled = checked ? true : false;
  }

  init() {
    this._createSelectYear();
    this._createSelectMonth();

    this.filterSearch && new FilterSearch(this.formFilters);

    if (this.selectRegion) {
      this._createSelectRegion();
      this.selectRegion
        .querySelector('.close--select')
        .addEventListener('click', () => this._closeSelect());
      this.selectRegion
        .querySelector('.button--apply')
        .addEventListener('click', () => this._closeSelect());
      this.overlay.addEventListener('click', () => this._closeSelect());

      document.addEventListener('click', e => {
        e.target.classList.contains('select-region__selected') ||
          e.target.closest('.select-region__mobile') ||
          window.innerWidth <= 768
          ? e.stopPropagation()
          : this._closeSelect();
      });
    }

    if (this.carouselNav) {
      this.carouselNav.addEventListener('click', e => {
        e.preventDefault();
        this._sliderNavButton(e.target.closest('.carousel-time__button'));
      });
    }

    if (this.topGlobalDateButton) {
      this.topGlobalDateButton.addEventListener('click', () =>
        this._activeCarouselTime()
      );
      this.closeCarouselTime.addEventListener('click', () =>
        this._closeCarouselTime()
      );
      this.carouselTime
        .querySelector('.button--apply')
        .addEventListener('click', () => this._closeCarouselTime());
      this.overlay.addEventListener('click', () => this._closeCarouselTime());
    }

    if (this.carouselTimeYearCheckbox) {
      this.carouselTimeYearCheckbox.addEventListener('change', e => {
        e.preventDefault();
        e.target.checked
          ? (e.target.setAttribute('checked', ''),
            this._toggleCheckbox(e.target.checked),
            window.innerWidth > 768 && this.formFilters.submit())
          : this._toggleCheckbox();
      });
    }
  }
}
